import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { AuthProvider, useAuth } from './providers/auth';
import './index.css';
import { router } from './router';

function App() {
  return (
    <AuthProvider>
      <RouterWithAuth />
    </AuthProvider>
  );
}

function RouterWithAuth() {
  const auth = useAuth();
  return <RouterProvider router={router} context={{ auth }} />;
}

const rootElement = document.getElementById('root');
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}
